import { SocialMedia } from 'constants/social-media'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import GenomateLogo from 'components/genomateLogo/GenomateLogo'
import LanguageSelector from 'components/languageSelector/LanguageSelector'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import ContactAndButtonBlock from './ContactAndButtonBlock'
import {
    SOCIAL_ICON_DIMENSIONS,
    useStaticPageStyles,
    useStyles
} from './StaticpageWrapper.styles'

type StaticPageWrapperProps = {
    title?: string
    children: ReactNode
    isContentPage?: boolean
    withContact?: boolean
    withHomeButton?: boolean
    withLanguageSelector?: boolean
    withExtraTitleSpacing?: boolean
}

const StaticPageWrapper = ({
    children,
    title,
    withContact = false,
    isContentPage = false,
    withHomeButton = false,
    withLanguageSelector = false,
    withExtraTitleSpacing = false
}: StaticPageWrapperProps) => {
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const styles = useStyles()
    const staticPageStyles = useStaticPageStyles()

    return (
        <Box className={styles.page}>
            <Box className={styles.container}>
                <Box className={styles.logoContainer}>
                    <Link to="/">
                        <GenomateLogo
                            fontSize={250}
                            width="32vh"
                            height="15vh"
                        />
                    </Link>
                    {withLanguageSelector && (
                        <Box className={styles.languageSelectorContainer}>
                            <LanguageSelector />
                        </Box>
                    )}
                </Box>
                <Box
                    className={`${styles.contentContainer}${
                        isContentPage
                            ? ` ${staticPageStyles.contentContainer}`
                            : ''
                    }`}
                >
                    {title && (
                        <Typography
                            className={styles.title}
                            variant={isLargeScreen ? 'h4' : 'h5'}
                            align="center"
                            sx={withExtraTitleSpacing ? { mt: 3 } : undefined}
                        >
                            {title}
                        </Typography>
                    )}
                    {children}

                    <ContactAndButtonBlock
                        styles={styles}
                        isLargeScreen={isLargeScreen}
                        withHomeButton={withHomeButton}
                        withContact={withContact}
                    />
                </Box>
                <Box className={styles.footer}>
                    <Divider className={styles.divider} />
                    <Typography
                        variant={isLargeScreen ? 'body2' : 'caption'}
                        className={styles.address}
                        sx={{ mt: 2, fontWeight: 600 }}
                    >
                        Genomate Health Inc - 1 Broadway, Cambridge, 02142, MA,
                        USA
                    </Typography>
                    <Box className={styles.socialMediaContainer} sx={{ mt: 2 }}>
                        {SocialMedia.map(({ url, alt, href }) => (
                            <a
                                key={alt}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={url}
                                    alt={alt}
                                    width={SOCIAL_ICON_DIMENSIONS}
                                    height={SOCIAL_ICON_DIMENSIONS}
                                />
                            </a>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default StaticPageWrapper
